import type { TarotSpread } from '../types/tarot';

export const spreads: TarotSpread[] = [
  {
    id: 'single-card',
    name: 'Single Card',
    description: 'A simple one-card reading for quick guidance',
    cardCount: 1,
    positions: [
      {
        id: 1,
        name: 'Your Card',
        description: 'The guidance you need right now',
        x: 50,
        y: 50
      }
    ]
  },
  {
    id: 'three-card',
    name: 'Past, Present, Future',
    description: 'A classic three-card spread showing the timeline of your situation',
    cardCount: 3,
    positions: [
      {
        id: 1,
        name: 'Past',
        description: 'What has led to this situation',
        x: 25,
        y: 50
      },
      {
        id: 2,
        name: 'Present',
        description: 'Your current situation',
        x: 50,
        y: 50
      },
      {
        id: 3,
        name: 'Future',
        description: 'The likely outcome',
        x: 75,
        y: 50
      }
    ]
  },
  {
    id: 'celtic-cross',
    name: 'Celtic Cross',
    description: 'A comprehensive 10-card spread for deep insight into your situation',
    cardCount: 10,
    positions: [
      { id: 1, name: 'Present Situation', description: 'Your current state and the heart of the matter', x: 50, y: 50 },
      { id: 2, name: 'Challenge', description: 'What crosses you or the main obstacle', x: 50, y: 35 },
      { id: 3, name: 'Distant Past', description: 'Foundation and root causes of the situation', x: 35, y: 50 },
      { id: 4, name: 'Recent Past', description: 'Recent influences and events leading to now', x: 50, y: 65 },
      { id: 5, name: 'Possible Outcome', description: 'What may come to pass if nothing changes', x: 50, y: 20 },
      { id: 6, name: 'Near Future', description: 'Immediate future and next steps', x: 65, y: 50 },
      { id: 7, name: 'Your Approach', description: 'How you approach the situation', x: 85, y: 80 },
      { id: 8, name: 'External Influences', description: 'How others see you and external factors', x: 85, y: 65 },
      { id: 9, name: 'Hopes and Fears', description: 'Your inner feelings and subconscious desires', x: 85, y: 50 },
      { id: 10, name: 'Final Outcome', description: 'The ultimate result and resolution', x: 85, y: 35 }
    ]
  }
];